
export type TMenu = {
  name: string;
  uri: string;
  icon: string;
  code: string;
  description?: string;
  id?: number;
  disabled?: boolean;
  isMain?: boolean;
  order?: number;
  path: string;
  serviceCode?: string;
  classNameIcon?: string;
  subs?: TMenu[];
  [x: string]: any;
  hasBullet?: boolean;
  permission?: string;
  ability?: string;
};

export const listModule: TMenu[] = [
	{
    "id": 1,
    "code": "",
    "name": "Danh sách bệnh nhân",
    "icon": '',
    "path": "",
    "uri": "/patients",
    "isMain": true,
    "disabled": false,
    "subs": [],
    "serviceCode": "oceantech-emr-server",
	},
	{
    "id": 2,
    "code": "",
    "name": "Hồ sơ bệnh án",
    "icon": '',
    "path": "",
    "uri": "/medical-records",
    "isMain": true,
    "disabled": false,
    "subs": [],
    "serviceCode": "oceantech-emr-server",
	},
	// {
  //   "id": 3,
  //   "code": "storage",
  //   "name": "Kho lưu trữ",
  //   "icon": '',
  //   "path": "",
  //   "uri": "/storages",
  //   "isMain": true,
  //   "disabled": false,
  //   "subs": [],
  //   "serviceCode": "oceantech-emr-server",
  // },
  {
    "id": 4,
    "code": "signature",
    "name": "Ký số",
    "icon": '',
    "path": "",
    "uri": "/signatures",
    "isMain": true,
    "disabled": false,
    "subs": [],
    "serviceCode": "oceantech-emr-server",
  },
  // {
  //   "id": 5,
  //   "code": "settings",
  //   "name": "Cài đặt",
  //   "icon": '',
  //   "path": "",
  //   "uri": "/settings",
  //   "isMain": true,
  //   "disabled": false,
  //   "subs": [],
  //   "serviceCode": "oceantech-emr-server",
  // },
  // {
  //   id: 6,
  //   code: "admission",
  //   name: "Bệnh án điện tử",
  //   description: "Bệnh án điện tử",
  //   icon: "",
  //   path: "/ADMISSION/",
  //   uri: "/benh-an-dien-tu",
  //   order: 1,
  //   orgId: null,
  //   parentId: null,
  //   isMain: true,
  //   disabled: false,
  //   uiComponent: null,
  //   subs: [],
  //   serviceCode: "oceantech-emr-server",
  // },
];
